import { createStyles, makeStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
    createStyles({
        root: {
            top: 0,
            left: 0,
            right: 0,
            height: '3px',
            position: 'absolute',
            background:
                'linear-gradient(90deg, #FBE53B 0%, #FF4F01 16.82%, #FF14B3 35.13%, #8000FF 55%, #00C1FF 80%, #17F036 99.62%)',
        },
        gutters: {
            left: theme.spacing(2),
            right: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                left: theme.spacing(3),
                right: theme.spacing(3),
            },
        },
    });

export default makeStyles(styles, { name: 'MuiColorfulBar' });
